import DefaultEmptyIcon from "./DefaultEmptyIcon.svelte";
import DefaultFilledIcon from "./DefaultFilledIcon.svelte";
import DefaultHalfIcon from "./DefaultHalfIcon.svelte";

export default {
    filled: DefaultFilledIcon,
    half: DefaultHalfIcon,
    empty: DefaultEmptyIcon,
};
